import React, { useState } from 'react';
import {
  Typography,
  Button,
  Input,
  InputGroup,
  Header,
  HeaderViewSwitcher,
  Tabs,
  FlexRow,
  Row as GridRow,
  Col,
} from 'design-system';
import { FilterIcon, InfoIcon } from '../../../design-system/components/Icons';
import { TAB_FIGMA_TEXT_ONLY, HEADER_DEMO_VIEW_OPTIONS } from './headerShowcaseData';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

export default function HeaderShowcase() {
  const [headerDemoView, setHeaderDemoView] = useState('list');
  const [headerDemoTab, setHeaderDemoTab] = useState('me');

  return (
    <>
        {/* Header (Figma task header — optional slots) */}
        <GridRow>
          <Col xs={12}>
            <div className="design-system-section">
              <Typography variant="h1" className="section-title mb-4">
                Header
              </Typography>
              <Separator className="mb-5" />
              <Typography variant="body2" className="mb-4 text-muted">
                Optional slots: <code>title</code>, <code>primaryAction</code>, <code>search</code>,{' '}
                <code>viewSwitcher</code>, <code>tabs</code>. Helpers: <code>HeaderViewSwitcher</code>. Compose only the
                rows you need.
              </Typography>
              <Typography variant="subtitle2" className="mb-2">
                Top Header
              </Typography>
              <div className="mb-5" style={{ overflow: 'hidden' }}>
                <Header
                  search={
                    <InputGroup prefix={<i className="simple-icon-magnifier" aria-hidden />}>
                      <Input placeholder="Search tasks..." aria-label="Search tasks" />
                    </InputGroup>
                  }
                  viewSwitcher={
                    <FlexRow align="center" gap={8} inline>
                      <Button variant="white" size="sm" icon={<FilterIcon size={18} />} />
                      <Button variant="white" size="sm" icon={<InfoIcon size={18} />} />
                      <Button variant="white" size="sm" icon={<FilterIcon size={18} />} />
                    </FlexRow>
                  }
                />
              </div>
              <Typography variant="subtitle2" className="mb-2">
                Header I — title + primary
              </Typography>
              <div className="mb-5" style={{ overflow: 'hidden' }}>
                <Header
                  title="Task Management"
                  primaryAction={
                    <Button variant="primary" size="sm" icon={<span aria-hidden>+</span>} iconPosition="left">
                      Create task
                    </Button>
                  }
                />
              </div>
              <Typography variant="subtitle2" className="mb-2">
                Header II — + search + view switcher
              </Typography>
              <div className="mb-5" style={{ overflow: 'hidden' }}>
                <Header
                  title="Task Management"
                  primaryAction={
                    <Button variant="primary" size="sm" icon={<span aria-hidden>+</span>} iconPosition="left">
                      Create task
                    </Button>
                  }
                  search={
                    <InputGroup prefix={<i className="simple-icon-magnifier" aria-hidden />}>
                      <Input placeholder="Search tasks..." aria-label="Search tasks" />
                    </InputGroup>
                  }
                  viewSwitcher={
                    <HeaderViewSwitcher
                      options={HEADER_DEMO_VIEW_OPTIONS}
                      value={headerDemoView}
                      onChange={setHeaderDemoView}
                    />
                  }
                />
              </div>
              <Typography variant="subtitle2" className="mb-2">
                Header III — + sub-tabs (underline <code>Tabs</code>)
              </Typography>
              <div className="mb-2" style={{ overflow: 'hidden' }}>
                <Header
                  title="Task Management"
                  primaryAction={
                    <Button variant="primary" size="sm" icon={<span aria-hidden>+</span>} iconPosition="left">
                      Create task
                    </Button>
                  }
                  search={
                    <InputGroup prefix={<i className="simple-icon-magnifier" aria-hidden />}>
                      <Input placeholder="Search tasks..." aria-label="Search tasks" />
                    </InputGroup>
                  }
                  viewSwitcher={
                    <HeaderViewSwitcher
                      options={HEADER_DEMO_VIEW_OPTIONS}
                      value={headerDemoView}
                      onChange={setHeaderDemoView}
                    />
                  }
                  tabs={
                    <Tabs
                      items={TAB_FIGMA_TEXT_ONLY}
                      value={headerDemoTab}
                      onChange={setHeaderDemoTab}
                      variant="underline"
                    />
                  }
                />
              </div>
            </div>
          </Col>
        </GridRow>
    </>
  );
}